import { Button, Card, Icon } from '@salesforce/design-system-react';
import { useId, useState } from 'react';

import { IconCategory } from '../../../shared/types/Enum';

interface LineItemSectionProps {
  action?: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  iconName: string;
  summary: string;
  title: string;
}

export const LineItemSection: React.FC<LineItemSectionProps> = ({
  action,
  children,
  defaultOpen = false,
  iconName,
  summary,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = useId();

  return (
    <Card
      className={`line-item-editor-section-card slds-card_boundary${
        isOpen ? ' line-item-editor-section-card-open' : ' line-item-editor-section-card-closed'
      }`}
      headerActions={
        <div
          className="line-item-editor-section-actions slds-grid slds-grid_vertical-align-center"
          style={{ gap: 'var(--slds-g-spacing-2)' }}
        >
          {action}
          <Button
            aria-controls={contentId}
            aria-expanded={isOpen}
            assistiveText={{ icon: `${isOpen ? 'Collapse' : 'Expand'} ${title}` }}
            className="line-item-editor-section-toggle"
            iconCategory={IconCategory.Utility}
            iconName={isOpen ? 'chevronup' : 'chevrondown'}
            onClick={() => {
              setIsOpen(open => !open);
            }}
            variant="icon"
          />
        </div>
      }
      heading={
        <div className="line-item-editor-section-heading">
          <span className="line-item-editor-section-title slds-text-heading_small">{title}</span>
          {summary && (
            <span className="line-item-editor-section-summary slds-text-body_small slds-text-color_weak">
              {summary}
            </span>
          )}
        </div>
      }
      icon={
        <Icon
          category={IconCategory.Utility}
          containerClassName={`slds-icon_container slds-icon-utility-${iconName}`}
          name={iconName}
          size="small"
          style={{ fill: 'var(--slds-g-color-accent-1)' }}
        />
      }
    >
      <div className="line-item-editor-section-content" hidden={!isOpen} id={contentId}>
        {children}
      </div>
    </Card>
  );
};
